import { CommonModule }                   from '@angular/common';
import { NgModule }                       from '@angular/core';
import { ParameterizedHtmlTextComponent } from './parameterized-html-text.component';


@NgModule( {
	declarations: [
		ParameterizedHtmlTextComponent
	],
	imports: [
		// Angular
		CommonModule
	],
	exports: [
		ParameterizedHtmlTextComponent
	]
} )
export class ParameterizedHtmlTextModule {}
